import AScene from "./AScene.js";

export default class ASprite extends Phaser.GameObjects.Sprite
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, x, y, animation)
    {
        super(scene, x, y, animation);
        if(animation != null) this.anims.play(animation);
        
        this.curFrameIdx = 0;
        this.frameListeners = [];
    }

    destroy()
    {
        let i = this.frameListeners.length;
        while(i)
        {
            i--;
            let n = this.frameListeners[i].listeners.length;
            while(n)
            {
                n--;
                this.frameListeners[i].listeners.pop();
                
            }
            this.frameListeners[i].listeners = null;
            delete this.frameListeners[i].listeners;

            this.frameListeners.pop();
        }

        super.destroy();
    }

    addListenerToFrame(frameIndex, listener, animationName = null)
    {
        let animation = animationName == null ? this.anims.currentAnim : this.anims.animationManager.anims.entries[animationName];
        if(frameIndex < 0 || frameIndex >= animation.frames.length)
        {
            console.warn("Frame index: " + frameIndex + " of animation: " + animation.key + " does not exist.");
            return;
        }
        if(animation.frames[frameIndex].listeners == null) 
        {
            animation.frames[frameIndex].listeners = [];
            this.frameListeners.push(animation.frames[frameIndex]);
        }
        animation.frames[frameIndex].listeners.push(listener);
    }

    setFrameIndex(index)
    {
        this.anims.setCurrentFrame(this.anims.currentAnim.frames[index]);
        this.curFrameIdx = index;
    }

    preUpdate(time, delta)
    {
        super.preUpdate(time, delta);

        if(!this.anims || this.anims.currentFrame.listeners == null) return;

        let frame = this.anims.currentFrame;
        if(frame.index != this.curFrameIdx)
        {
            this.curFrameIdx = frame.index;
            if(frame.listeners)
            {
                let iters = frame.listeners.length;
                for(let i = 0; i < iters; i++) frame.listeners[i]();
            }
        }
    }
}